export default __webpack_public_path__ + "static/media/squares300.17038507.jpg";